import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faTimes,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";
import "../styles/stihl-tips.css";

import pic1 from "../assets/images/carousel/1-motor.jpg";
import pic2 from "../assets/images/carousel/2-concesionarios.jpg";
import pic3 from "../assets/images/carousel/3-bateria.jpg";
import pic4 from "../assets/images/carousel/4-poda.jpg";
import pic5 from "../assets/images/carousel/5-hidro.jpg";
import pic6 from "../assets/images/carousel/6-cadena.jpg";
import pic7 from "../assets/images/carousel/7-hilo.jpg";
import pic8 from "../assets/images/carousel/8-oidos.jpg";
import pic9 from "../assets/images/carousel/9-valvula.jpg";

const StihlTips = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedTip, setSelectedTip] = useState(null);
  const [visibleSlides, setVisibleSlides] = useState(3);

  const tips = [
    {
      id: 1,
      title: "Calentamiento del motor",
      category: "PRO TIPS",
      image: pic1,
      shortDesc: "Conocé los secretos del calentamiento correcto",
      fullContent: `
        <h3>Calentamiento correcto del motor</h3>
        <p>Después de encender la máquina y liberar el freno de cadena, debes realizar un calentamiento con pequeños golpes de aceleración. Esto permite purgar todo el aire que pudo haber quedado dentro del carburador y permite lubricar la espada y cadena.</p>
        
        <p>El calentamiento permite al pistón absorber calor y alcanzar la temperatura de operación correcta.</p>
        
        <div class="tip-highlight">
          <strong>¡Importante!</strong> No es correcto acelerar por más de 10 segundos la motosierra sin ninguna carga, sin importar si es nueva o no.
        </div>
      `,
    },
    {
      id: 2,
      title: "Concesionario oficial",
      category: "SEGURIDAD",
      image: pic2,
      shortDesc: "El tip de seguridad más importante",
      fullContent: `
        <h3>¿Por qué comprar en un concesionario oficial?</h3>
        <p>Al comprar en un concesionario STIHL oficial te estás llevando muchas cosas además de una tremenda herramienta: la seguridad de que estás haciendo una compra oficial, con garantía y atención post-venta aseguradas.</p>
        
        <h4>Beneficios:</h4>
        <ul>
          <li>Garantía oficial</li>
          <li>Atención post-venta asegurada</li>
          <li>Productos genuinos STIHL</li>
          <li>Asesoramiento profesional</li>
        </ul>
      `,
    },
    {
      id: 3,
      title: "Batería en perfectas condiciones",
      category: "PRO TIPS",
      image: pic3,
      shortDesc: "Maximizá la vida útil de tus baterías",
      fullContent: `
        <h3>Cuidado de baterías</h3>
        <p>Si vas a guardar tu batería por un buen rato, es importante que esta cuente por lo menos con 2 líneas de carga, de esa forma le darás mayor vida útil a la batería durante el periodo de almacenamiento.</p>
        
        <h4>Consejos adicionales:</h4>
        <ul>
          <li>Guardá la batería en lugar fresco y seco</li>
          <li>Evitá temperaturas extremas</li>
          <li>Cargá completamente antes de guardar por períodos largos</li>
        </ul>
      `,
    },
    {
      id: 4,
      title: "Poda de árboles urbanos",
      category: "SEGURIDAD",
      image: pic4,
      shortDesc: "Importancia de la poda profesional",
      fullContent: `
        <h3>Poda de árboles en zonas urbanas</h3>
        <p>En zonas urbanas, la poda de árboles no sólo ayuda a mantener las veredas y jardines más lindos, también es fundamental para la seguridad de todos.</p>
        
        <h4>¿Por qué es importante?</h4>
        <ul>
          <li>Las ramas podridas, enfermas o muertas pueden alojar enfermedades</li>
          <li>Son peligrosas ya que pueden desprenderse solas</li>
          <li>Los arboles que dan a la calle se deben podar para evitar accidentes o destrucción de vehículos en caso de tormenta</li>
        </ul>
        
        <div class="tip-highlight">
          <strong>¡Recordá!</strong> Para hacerlo de forma correcta, es fundamental dejarlo en manos de profesionales.
        </div>
      `,
    },
    {
      id: 5,
      title: "Uso correcto de hidrolavadora",
      category: "PRO TIPS",
      image: pic5,
      shortDesc: "Cuidados esenciales para tu hidrolavadora",
      fullContent: `
        <h3>Antes de empezar a trabajar</h3>
        <p>Abrí la llave de agua y con el interruptor apagado, accioná el gatillo de la pistola. Debe salir un chorro constante de agua. Con esto eliminaras todo el aire dentro de la bomba y facilitaras el encendido inicial de la hidrolavadora.</p>
        
        <h3>Al terminar de trabajar</h3>
        <p>Cerrá la llave de agua y con el interruptor apagado accioná el gatillo de la pistola. Debe salir un chorro constante de agua hasta terminarse. Con esto se elimina el agua dentro de la bomba y evitás la formación de sedimentos en tu equipo, sobre todo cuando dejes tu equipo inactivo por periodos medianos o largos.</p>
      `,
    },
    {
      id: 6,
      title: "Destensa la cadena",
      category: "MANTENIMIENTO",
      image: pic6,
      shortDesc: "Prolonga la vida de tu cadena",
      fullContent: `
        <h3>Al terminar la jornada</h3>
        <p>Cuando termines la jornada de trabajo con tu motosierra, te recomendamos destensar la cadena y desmontar la barra.</p>
        
        <h4>Beneficios:</h4>
        <ul>
          <li>Facilita la limpieza de la máquina</li>
          <li>Ayuda a prolongar la vida de la cadena</li>
          <li>Previene deformaciones por tensión prolongada</li>
        </ul>
      `,
    },
    {
      id: 7,
      title: "Hidrata el hilo nylon",
      category: "PRO TIPS",
      image: pic7,
      shortDesc: "Hacé durar más tu hilo nylon",
      fullContent: `
        <h3>Preparación Previa</h3>
        <p>Es importante que, una noche antes de iniciar tu jornada de trabajo con cualquiera de nuestras motoguadañas STIHL, metas la cantidad de hilo nylon que vayas a utilizar en una cubeta con agua y lo dejes reposar toda la noche.</p>
        
        <h4>¿Por qué funciona?</h4>
        <p>Ese hilo, ya que es un polímero, absorberá líquidos y hará que se vuelva más resistente y elástico. Durará mucho más tiempo trabajando sin que lo tengas que estar reemplazando por tiempos muy cortos debido a que se reseca.</p>
      `,
    },
    {
      id: 8,
      title: "STIHL cuida tus oídos",
      category: "SEGURIDAD",
      image: pic8,
      shortDesc: "Protección auditiva profesional",
      fullContent: `
        <h3>Protección auditiva</h3>
        <p>Se recomienda el uso de protección auditiva a partir de solo 80 dB para proporcionar la mejor protección posible para tus oídos. Por eso, STIHL te cuida ofreciéndote diferentes opciones.</p>
        
        <h4>Opciones de protección:</h4>
        <ul>
          <li><strong>Tapones para los oídos:</strong> ideales para períodos más largos y con mayor comodidad</li>
          <li><strong>Cascos de protección auditiva:</strong> son adecuados para todo tipo de trabajos, tanto en interiores como exteriores</li>
        </ul>
        
        <div class="tip-highlight">
          <strong>¡Importante!</strong> Si estás expuesto a niveles de ruido extremadamente altos, podés usar tapones y cascos de protección para los oídos al mismo tiempo.
        </div>
      `,
    },
    {
      id: 9,
      title: "Válvula ULV en fumigadoras",
      category: "PRO TIPS",
      image: pic9,
      shortDesc: "Optimizá tu fumigadora",
      fullContent: `
        <h3>¿Qué es la válvula ULV?</h3>
        <p>La válvula ULV (color gris) es un accesorio que se vende por separado para todas las fumigadoras de motor. Reduce el tamaño de la gota, y esto permite una mejor adherencia del activo en las hojas.</p>
        
        <h4>Ventajas:</h4>
        <ul>
          <li>Reduce el tamaño de la gota</li>
          <li>Mejor adherencia del activo en las hojas</li>
          <li>Reduce el caudal, extendiendo la duración del tanque</li>
          <li>El tanque puede durar hasta 2.75 veces más</li>
        </ul>
        
        <h4>Diferencia con válvula estándar:</h4>
        <p><strong>Válvula ULV (gris):</strong> 0.04 litros/minuto<br>
        <strong>Válvula estándar (naranja):</strong> 0.11 litros/minuto</p>
      `,
    },
  ];

  useEffect(() => {
    const updateVisibleSlides = () => {
      if (window.innerWidth <= 768) {
        setVisibleSlides(1);
      } else if (window.innerWidth <= 1024) {
        setVisibleSlides(2);
      } else {
        setVisibleSlides(3);
      }
    };

    updateVisibleSlides();

    window.addEventListener("resize", updateVisibleSlides);

    return () => window.removeEventListener("resize", updateVisibleSlides);
  }, []);

  useEffect(() => {
    setCurrentSlide(0);
  }, [visibleSlides]);

  const maxSlide = Math.max(0, tips.length - visibleSlides);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev < maxSlide ? prev + 1 : 0));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev > 0 ? prev - 1 : maxSlide));
  };

  const openModal = (tip) => {
    setSelectedTip(tip);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedTip(null);
    document.body.style.overflow = "unset";
  };

  return (
    <section className="stihl-tips-section">
      <div className="stihl-tips-container">
        <div className="stihl-tips-header">
          <div className="section-label">
            <FontAwesomeIcon icon={faLightbulb} /> APRENDE CON NOSOTROS
          </div>
          <h2 className="section-title">STIHL Tips</h2>
          <p className="section-subtitle">
            Consejos profesionales para sacar el máximo provecho de tus
            herramientas
          </p>
        </div>

        <div className="carousel-wrapper">
          <button
            className="carousel-nav prev"
            onClick={prevSlide}
            aria-label="Anterior"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          <div className="carousel-container">
            <div
              className="carousel-track"
              style={{
                transform: `translateX(-${currentSlide * (100 / visibleSlides)}%)`,
              }}
            >
              {tips.map((tip) => (
                <div
                  key={tip.id}
                  className="tip-card"
                  onClick={() => openModal(tip)}
                >
                  <div className="tip-image">
                    <img src={tip.image} alt={tip.title} loading="lazy" />
                    <div className="tip-overlay">
                      <div className="tip-category">{tip.category}</div>
                      <h3 className="tip-title">{tip.title}</h3>
                      <p className="tip-short-desc">{tip.shortDesc}</p>
                      <button className="tip-read-more">Leer más →</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            className="carousel-nav next"
            onClick={nextSlide}
            aria-label="Siguiente"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>

        <div className="tips-indicators">
          {Array.from({ length: maxSlide + 1 }).map((_, index) => (
            <button
              key={index}
              className={`tips-indicator ${currentSlide === index ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Ir a grupo ${index + 1}`}
            />
          ))}
        </div>
      </div>

      {selectedTip && (
        <div className="stihl-tips-modal-overlay" onClick={closeModal}>
          <div
            className="stihl-tips-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="stihl-modal-close" onClick={closeModal}>
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <div className="stihl-modal-header">
              <div className="stihl-modal-category">{selectedTip.category}</div>
              <h2 className="stihl-modal-title">{selectedTip.title}</h2>
            </div>

            <div className="stihl-modal-image">
              <img
                src={selectedTip.image}
                alt={selectedTip.title}
                loading="lazy"
              />
            </div>

            <div
              className="stihl-modal-content"
              dangerouslySetInnerHTML={{ __html: selectedTip.fullContent }}
            />

            <div className="stihl-modal-footer">
              <button className="stihl-modal-cta" onClick={closeModal}>
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="stihl-tips-cta">
        <p className="stihl-tips-cta-text">
          ¿Querés aprender más? Tenemos tutoriales completos sobre arranque,
          mantenimiento de cadenas, mezcla de combustible y mucho más.
        </p>
        <Link to="/videos" className="stihl-tips-cta-btn">
          Ver tutoriales
        </Link>
      </div>
    </section>
  );
};

export default StihlTips;
